import { Mark } from "@tiptap/core";

declare module "@tiptap/core" {
    interface Commands<ReturnType> {
        citationHighlight: {
            setCitationHighlight: (from: number, to: number) => ReturnType;
            unsetCitationHighlight: () => ReturnType;
        };
    }
}

export const CitationHighlightMark = Mark.create({
    name: "citationHighlight",

    parseHTML() {
        return [{ tag: 'mark[data-citation-highlight="true"]' }];
    },

    renderHTML() {
        return [
            "mark",
            {
                "data-citation-highlight": "true",
                class: "bg-bronze-200 rounded-sm py-px px-1 -mx-1 [box-decoration-break:clone] shadow-[0_0_0_2px_theme(colors.bronze.600),0_0_0_4px_rgba(167,101,2,0.18)] transition-colors",
            },
            0,
        ];
    },

    addCommands() {
        return {
            setCitationHighlight:
                (from: number, to: number) =>
                ({ tr, dispatch }) => {
                    if (dispatch) {
                        const markType = this.type;
                        tr.addMark(from, to, markType.create());
                    }
                    return true;
                },

            unsetCitationHighlight:
                () =>
                ({ tr, state, dispatch }) => {
                    if (dispatch) {
                        const markType = this.type;
                        tr.removeMark(0, state.doc.content.size, markType);
                    }
                    return true;
                },
        };
    },
});
